import * as React from 'react'
import { useState } from 'react'

import { Box, Icon, Tag, Text, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { attendanceSettingVersionIndex } from 'modules/attendance/store/collections/settings'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import Content from './_Content'

interface Props {
  attendanceSetting: AttendanceSetting
  current: boolean
  selected: boolean
  loading: boolean
  onClick: () => void
}

const Item = ({ attendanceSetting, current, selected, loading, onClick }: Props) => {
  const [isHovering, toggleHovering] = useToggle(false)
  const [openSettingsEvents, toggleSettingsEvents] = useState<boolean>(false)
  const changesText = openSettingsEvents
    ? i18n.t('time_tracking.settings.versions.sidepanel.hide_changes')
    : i18n.t('time_tracking.settings.versions.sidepanel.show_changes')

  const onClickSettingsEvents = (event: MouseEvent) => {
    toggleSettingsEvents(!openSettingsEvents)
    event.stopPropagation()
  }

  return (
    <Box
      key={attendanceSetting.attributes.id}
      border={{ all: { width: 's1', style: 'solid', color: selected ? 'grey800' : 'grey400' } }}
      borderRadius={{ all: 'abs008' }}
      background={isHovering ? 'grey200' : 'grey000White'}
      cursor="pointer"
      onMouseEnter={toggleHovering(true)}
      onMouseLeave={toggleHovering(false)}
      onClick={onClick}
    >
      <Box
        padding="s16"
        gap="s16"
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
      >
        <Box gap="s4">
          <Text size="300" color="grey1000" weight="medium">
            {i18n.t('time_tracking.settings.versions.version_with_index', {
              index: attendanceSettingVersionIndex(attendanceSetting),
            })}
          </Text>
          <Text size="200" color="grey800" weight="medium">
            {i18n.t('time_tracking.settings.versions.effective_date')}{' '}
            {dateToString(attendanceSetting.effectiveAt, 'ui')}
          </Text>
        </Box>
        {current && (
          <Box>
            <Tag type={Tag.Types.malibu}>
              {i18n.t('time_tracking.settings.versions.sidepanel.current')}
            </Tag>
          </Box>
        )}
        {attendanceSetting.future && !current && (
          <Box>
            <Tag type={Tag.Types.grey}>
              {i18n.t('time_tracking.settings.versions.sidepanel.future')}
            </Tag>
          </Box>
        )}
      </Box>
      <Box onClick={onClickSettingsEvents}>
        <Box
          paddingX="s16"
          paddingY="s8"
          gap="s4"
          flexDirection="row"
          alignItems="center"
          border={{ top: { width: 's1', style: 'solid', color: 'grey400' } }}
        >
          <Icon.Medium icon="history" color="grey600" />
          <Text size="200" color="grey800" weight="medium">
            {changesText}
          </Text>
          <Icon.Small icon={openSettingsEvents ? 'chevron-up' : 'chevron-down'} color="grey800" />
        </Box>
        {openSettingsEvents && <Content attendanceSetting={attendanceSetting} loading={loading} />}
      </Box>
    </Box>
  )
}

export default observer(Item)
